export const WEBIEW_MESSAGE = {
  NEW_STARTUP: 'NEW_STARTUP',
  NEW_FUND: 'NEW_FUND',
};
